// Lightweight gtag helpers. All calls are no-ops if gtag is unavailable.
const GA_ID = process.env.REACT_APP_GA_ID || "AW-18128721277";

function safeGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackEvent(name, params = {}) {
  safeGtag("event", name, { send_to: GA_ID, ...params });
}

export function trackLead(source = "unknown", extras = {}) {
  // 'generate_lead' is a GA4 recommended event — marks as conversion easily.
  trackEvent("generate_lead", {
    method: source,
    currency: "INR",
    value: 0,
    ...extras,
  });
}

export function trackWhatsApp({ link_url, link_text, page_path }) {
  trackEvent("whatsapp_click", { link_url, link_text, page_path });
}

export function trackPhone({ link_url, page_path }) {
  trackEvent("phone_click", { link_url, page_path });
}
